// Generated by Melange

import * as Buhta_cabinet__PdfLoading from "./PdfLoading.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactPdf from "react-pdf";
import * as JsxRuntime from "react/jsx-runtime";

function PdfCanvas(Props) {
  let multi = Props.multi;
  let hash = Props.hash;
  let previewUrl = Props.previewUrl;
  let orientation = Props.orientation;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
    return 0;
  });
  const setWindowWidth = match[1];
  const windowWidth = match[0];
  const match$1 = React.useState(function () {
    return false;
  });
  const setShowZoom = match$1[1];
  const match$2 = React.useState(function () {
    return false;
  });
  const setPreviewImageClicked = match$2[1];
  React.useEffect((function () {
    Curry._1(setWindowWidth, (function (param) {
      if (deviceType === "mobile") {
        return window.innerWidth - 32 | 0;
      } else {
        return window.innerWidth - (
          multi ? 634 : 426
        ) | 0;
      }
    }));
    Curry._1(setPreviewImageClicked, (function (param) {
      return false;
    }));
  }), [hash]);
  let tmp;
  if (match$2[0]) {
    tmp = JsxRuntime.jsx(ReactPdf.Document, {
      children: JsxRuntime.jsx(ReactPdf.Page, {
        pageNumber: 1,
        width: windowWidth,
        loading: JsxRuntime.jsx(Buhta_cabinet__PdfLoading.make, {
          width: windowWidth
        })
      }),
      file: "/api/edo/sign/v1alpha1/public/" + hash + "/content",
      onLoadSuccess: (function (param) {
        Curry._1(setShowZoom, (function (param) {
          return true;
        }));
      }),
      loading: JsxRuntime.jsx(Buhta_cabinet__PdfLoading.make, {
        width: windowWidth
      }),
      error: JsxRuntime.jsx(Buhta_cabinet__PdfLoading.make, {
        width: windowWidth
      })
    });
  } else {
    let tmp$1;
    if (previewUrl !== undefined) {
      let tmp$2;
      if (orientation !== undefined) {
        switch (orientation) {
          case /* DOCUMENT_ORIENTATION_PORTRAIT */ 1 :
            tmp$2 = "lg:h-screen";
            break;
          case /* DOCUMENT_ORIENTATION_UNSPECIFIED */ 0 :
          case /* DOCUMENT_ORIENTATION_LANDSCAPE */ 2 :
            tmp$2 = "lg:w-full";
            break;
        }
      } else {
        tmp$2 = "lg:w-full";
      }
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: Cn.fromList({
                hd: tmp$2,
                tl: {
                  hd: "cursor-pointer",
                  tl: /* [] */ 0
                }
              }),
              src: previewUrl
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                className: "w-6 h-6",
                alt: "zoom",
                src: StaticAsset.src("/static/icons/fullscreen-black-24.svg")
              }),
              className: "absolute top-6 right-6 rounded-full bg-gray-main p-3 cursor-pointer"
            })
          ],
          className: "relative"
        }),
        className: "w-full flex justify-center items-center",
        onClick: (function (param) {
          Curry._1(setPreviewImageClicked, (function (param) {
            return true;
          }));
        })
      });
    } else {
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "mt-4 text-default-gray",
          children: "Предварительный просмотр недоступен. Нажмите сюда для загрузки полного документа."
        }),
        className: "w-full h-[800px] bg-white flex flex-col items-center justify-center cursor-pointer",
        onClick: (function (param) {
          Curry._1(setPreviewImageClicked, (function (param) {
            return true;
          }));
        })
      });
    }
    tmp = JsxRuntime.jsx("div", {
      children: tmp$1,
      className: "w-full lg:px-8 pb-10"
    });
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "relative flex justify-center w-full"
  });
}

const make = PdfCanvas;

export {
  make,
}
/* Buhta_cabinet__PdfLoading Not a pure module */
